import { Link } from 'react-router-dom';

import { MDText } from 'i18n-react';

import { ReactComponent as DownGraphIcon } from '../../../../../../client/assets_seller/DownGraphIcon.svg';
import { CUSTOMER_HUB_VALUATION_ROUTE } from '../../../../../containers/app/customerHub/CustomerHubHelpers';

import { ActionTile } from './ActionTile';
import LocalTexts from './ActionTiles.texts.json';

import styles from './TrackActionTile.module.scss';

const LocalT = new MDText(LocalTexts.track);

type TrackActionTileProps = {
  onClick?: () => void;
};

export const TrackActionTile = ({ onClick }: TrackActionTileProps) => {
  const handleClick = () => {
    onClick?.();
  };

  return <Link data-thc-style-override className={styles.trackActionTile} onClick={handleClick} rel='noopener noreferrer' target='_blank' to={CUSTOMER_HUB_VALUATION_ROUTE}>
    <ActionTile icon={() => <DownGraphIcon />} text={LocalT.translate('text')} title={LocalT.translate('title')} />
  </Link>;
};
